<template>
  <div>
    <div class="game" v-show="!reaction">
      <div class="shulte__body">
        <div class="train__info" v-if="active">
          <div class="train__item" uk-tooltip="Ошибок сделано">
            <div class="train__ico train__ico--2"></div>
            <small>Ошибок:</small>
            {{ errors }}
          </div>
          <div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
            <div class="train__ico train__ico--4"></div>
            <small>Выполнено:</small>
            <div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
          </div>
          <div class="train__item" uk-tooltip="Времени прошло">
            <div class="train__ico train__ico--3"></div>
            <div>
              <small>Времени прошло:</small>
              <!--<br class="uk-visible@s">-->
              {{ timer.minutes }} мин. {{ timer.seconds }} сек.
            </div>
          </div>
        </div>
      </div>

      <div class="spritz">
        <div class="spritz__body">
          <div class="spritz__text">
            <span v-if="activeCountDown">{{countdown}}</span>
            <span>{{ currentWord.start }}</span><span class="red">{{ currentWord.middle }}</span><span>{{ currentWord.end }}</span>
          </div>
        </div>
        <div class="spritz__control" v-if="!params.finish">
          <label>
            <span>Скорость: {{ params.speed }} слов в минуту</span>
            <input type="range" class="uk-range" v-model="params.speed" min="50" max="1000" step="1">
          </label>
          <button class="uk-button uk-button-primary" @click="pause = !pause">{{ pause ? 'Продолжить' : 'Пауза' }}</button>
        </div>
      </div>


      <div v-if="params.finish">
        <!--
        <h3>Твоё время - {{ timer.minutes }} мин. {{ timer.seconds }} сек.</h3>-->
        <h2>Отлично! Молодец! Повторим?</h2>
        <p class="scores">И ты зарабатываешь
          <strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
        <button class="uk-button uk-button-primary" @click="startGame" v-if="!checkFinishHomework()">Повторить!</button>
        <button class="uk-button uk-button-primary" @click="onStopTrainer" v-else>Закончить</button>
      </div>
      <a href="#" @click.prevent="onStopTrainer">Остановить</a>
    </div>

    <div class="wh-block wh-block--reaction" v-if="reaction">
      <div class="reaction">
        <!--<video loop muted preload="auto" autoplay>-->
        <video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
          <source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mix } from "./../mixin";
import { spritz } from "./spritz";

export default {
  name: "game",
  mixins: [
    mix, spritz
  ],
  data() {
    return {
      cifs: '',
      shuffle: '',
      active: false,
      step: 0,
      errors: 0,
      nextCif: '',
      currentCif: '',
      reaction: false,
      scores: 0,
      countdown: '',
      activeCountDown: true
    }
  },
  computed: {
    ...mapState({
      params: state => state.train.spritz_params
    }),
    finish() {
      return this.params.finish
    },
    user() {
      return this.$store.state.user;
    },
  },
  inject: ['http'],
  methods: {

    nexStep() {
      this.step++;
      if (this.step == this.cifs.length) {
        this.stopGame();
        this.$parent.commitVal(true, 'finish')
        this.addScores();
        this.makeStats();
        this.startReaction();
      }
    },

    stopGame() {
      this.active = false;
      this.activeCountDown = true
      this.$parent.commitVal(true, 'finish');
    },

    async startGame() {
      this.currentWord = '';
      this.scroll();
      this.params.finish = false;
      this.step = 0;
      this.errors = 0;
      this.activeCountDown = true
      await this.countDown()
      this.startTimer();
      this.active = true;
      this.startApp();
    },
    async countDown() {
        let arr = ['На старт!', 'Внимание', 'Марш!'];
        let app = this;

        function setStep(currentStep) {
          app.countdown = currentStep;
        }

        setStep('На старт!');
        for (let i = 1; i < 3; i++) {
          await this.sleep(1000);
          setStep(arr[i]);
        }
        await this.sleep(1000);
        this.activeCountDown = false
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    addScores() {
      console.log('add scores');
      let sum = 0;

      let scores = +this.params.speed / 100;

      sum = Math.ceil(scores);

      if (this.$route.params.isHomework) {
        sum = Math.ceil(sum * this.$store.state.hw_coefficient);
      }
      this.checkScoreStatus(sum);
      this.scores = sum;

      this.$store.commit('changeUserScores', sum);
      console.log('Баллов заработано', sum);
    },
    makeStats() {
      console.log("Make stats");
      if (this.user.role.code === 'student') {
        console.log('Бережно сохраняем статистику');

        let time = this.timer;
        let train_params = this.params;
        let stats = {
          time: time,
          errors: 0,
          user_id: this.$store.state.user.id,
          trainer: this.$store.state.current_trainer.id,
          scores: this.scores,
          train_params: {
            speed: train_params.speed,
            text_id: this.params.text_id
          }
        }

        stats = this.checkHomework(stats);
        let data = {
          'stat': stats
        }
        console.log(stats);
        this.http.post('onSaveStats', data).then((res) => {
          this.checkCoins(res.data);
        })
        .catch(e => swal('Статистика не сохранена', '' + e, 'error'))

      } else {
        console.log('Учителей в статистику не заносим! Понятно?!');
      }
    },
    /** РЕАКЦИИ */
    startReaction() {
      if (this.params.show_reactions) {
        let type = (this.errors === 0 ? 'react_plus' : 'react_minus');
        this.reaction_file = this.checkReaction(type);
        this.reaction = true;
      }
    },
    stopReaction() {
      this.reaction = false;
      let app = this;
      setTimeout(function () {
        app.scroll();
        $('#repeat-' + app.inkey).focus();
      }, 100);
    },
    scroll() {
      UIkit.scroll('.headline2').scrollTo('.game');
    },
  },
  async mounted() {
    await this.checkHasText();
    this.startGame();
  },
  beforeDestroy() {
    //this.makeStats();
    //this.stopSpritzTimer();
    this.params.start = false;
    //this.$parent.commitVal(false, 'start')
  }
}
</script>